// Fits a grid column to its content: the width of the widest rendered value and the (2-line-wrapped)
// header, clamped to [min, max]; content wider than `max` wraps and grows the row height.

import { measureBody, measureHeader } from './textWidth';

/** RevoGrid compact horizontal cell padding (0 15px → 30px total). */
export const COL_PAD = 30;
// Header room for the sort / filter icons that sit beside the label in a sortable+filterable column.
const HEADER_ICON_PAD = 24;
// Headers wrap to at most 2 lines (see index.css), so a column needs only ~half the single-line
// header width — but never less than its widest unbreakable word (which can't wrap).
const HEADER_LINES = 2;

interface FitInput {
  header: string;
  /** Every rendered cell value in the column (across all rows). */
  values: string[];
  min: number;
  max: number;
  /** Whether the header shows sort/filter icons that share its horizontal space. */
  hasIcons: boolean;
}

export function fitColumnWidth({
  header,
  values,
  min,
  max,
  hasIcons,
}: FitInput): number {
  let body = 0;
  for (const value of values) body = Math.max(body, measureBody(value));

  let longestWord = 0;
  for (const word of header.split(/\s+/)) {
    if (word) longestWord = Math.max(longestWord, measureHeader(word));
  }
  const headerNeed =
    Math.max(longestWord, measureHeader(header) / HEADER_LINES) +
    (hasIcons ? HEADER_ICON_PAD : 0);

  const content = Math.max(body, headerNeed) + COL_PAD;
  return Math.round(Math.min(max, Math.max(min, content)));
}
